// extracted by mini-css-extract-plugin
export default {"avatarImageWrap":"avatar-cropper_avatarImageWrap__9pj+z"};